module.exports = __webpack_public_path__ + "img/warning2.866ceaa8.svg";